import { _Security } from "../../services/core";
var useDiagnosticAction = function useDiagnosticAction() {
  var handleAction = function handleAction(type, diag) {
    if (diag.actionFronts && Array.isArray(diag.actionFronts)) {
      diag.actionFronts.forEach(function (actionFront) {
        if (actionFront.type === type) {
          if (actionFront.action.redirect) {
            window.open(actionFront.action.redirect, '__blank');
          }
        }
      });
    }
  };
  return {
    startEndAction: function startEndAction(diag) {
      return handleAction('end', diag);
    }
  };
};
export default useDiagnosticAction;